import { Component } from 'react'
import PropTypes from 'prop-types'

class Toggle extends Component {
    getClassName = (type) => {
        return {
            radio: 'toggle--radio',
            checkbox: 'toggle--checkbox',
            switch: 'toggle--switch'
        }[type];
    }

    render() {
        const { type, checked, disabled, children, ...props } = this.props
      
        let className = this.getClassName(type)
        if (!className)
            throw new Error('Invalid type passed to Toggle: ' + type)
        
        if (checked) 
            className += ' toggle--on'
        if (disabled) 
            className += ' toggle--disabled'

        return (
            <label className={"toggle " + className}>
                { type === 'radio' ?
                    <input type="radio" {...props} checked={checked} disabled={disabled} /> :
                    <input type="checkbox" {...props} checked={checked} disabled={disabled} /> }
                <div className="toggle__icon">
                    { type === 'checkbox' ? (
                        <svg className="toggle__icon__svg" viewBox="0 0 100 100">
                            <path d="M 10 60 L 40 80 L 90 20" />
                        </svg>
                    ) : null }
                </div>
                <span dangerouslySetInnerHTML={{ __html: children }}></span>
            </label>
        )
    }
}

Toggle.propTypes = {
    type: PropTypes.string.isRequired
}

export default Toggle

